import { render, staticRenderFns } from "./ComboboxSubsidio.vue?vue&type=template&id=b85a392c&scoped=true"
import script from "./ComboboxSubsidio.vue?vue&type=script&lang=js"
export * from "./ComboboxSubsidio.vue?vue&type=script&lang=js"
import style0 from "./ComboboxSubsidio.vue?vue&type=style&index=0&id=b85a392c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85a392c",
  null
  
)

export default component.exports